import { EntryScreen } from '@/components/entry/entry-screen';

export default function LoginPage() {
  return <EntryScreen variant="renter" />;
}
